import React from 'react';

interface ErrorMessageProps {
  message: string;
  showHomeButton?: boolean;
  className?: string;
}

/**
 * A reusable error message component
 */
const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  showHomeButton = true,
  className = ''
}) => {
  return (
    <div className={`bg-white p-8 rounded-lg shadow-md max-w-md w-full ${className}`}>
      <h2 className="text-2xl font-bold text-red-600 mb-4">Error</h2>
      <p className="text-gray-700 mb-6">{message}</p>
      {showHomeButton && (
        <button
          onClick={() => window.close()}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Close Window
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;